import React from 'react';
import { BsFacebook, BsGithub, BsInstagram } from 'react-icons/bs';
import logo from '../assets/logo.png';
const Footer = () => {
    return (
        <footer className="p-10 footer bg-indigo-700 text-primary-content footer-center">
            <div>
                <img
                    className="block h-12 w-auto"
                    src={logo}
                    alt="logo"
                />
                <h1 className="text-white ml-2 font-semibold text-xl font_poppins select-none">Language School</h1>
                <p>Copyright © 2021 - All right reserved</p>
            </div>
            <div>
                <div className="grid grid-flow-col gap-4">
                    {/* icons  */}
                    <a href="http://www.facebook.com/abtahinoorsm" target="_blank" rel="noopener noreferrer">
                        <BsFacebook className="w-8 h-8" />
                    </a>
                    <a href="http://www.instagram.com/smabtahinoor" target="_blank" rel="noopener noreferrer">
                        <BsInstagram className="w-8 h-8" />
                    </a>
                    <a href="http://www.github.com/19smabtahinoor" target="_blank" rel="noopener noreferrer">
                        <BsGithub className="w-8 h-8" />
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
